module.exports = __webpack_public_path__ + "static/media/speaker2.e9c2867c.png";